import { render, staticRenderFns } from "./SidingFeatures.vue?vue&type=template&id=9933489a"
import script from "./sidingFeatures.ts?vue&type=script&lang=js&external"
export * from "./sidingFeatures.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports